import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../_helpers/apiConfig";


export const adminList = createAsyncThunk("/admin/adminList", async (filters) => {
  const response = await apiRequest('POST', 'v1/admin/adminList', filters);
  return response;
});



export const saveAdmin = createAsyncThunk("/admin/saveAdmin",
  async (arg, thunkAPI) => {
    const { Payload, } = arg;
    const response = await apiRequest("POST", "v1/admin/saveAdmin", Payload);
    if (response.message) {
      thunkAPI.dispatch(adminList());
    }
    return response;
  }
);




export const adminStatusUpdate = createAsyncThunk("/admin/adminStatusUpdate",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh } = arg;
    const response = await apiRequest("POST", "v1/admin/adminStatusUpdate", Payload);
    if (response.message) {
      thunkAPI.dispatch(adminList());
    }
    return response;
  }
);



// export const deleteAppSetting = createAsyncThunk("/appSetting/deleteAppSetting",
//   async (arg, thunkAPI) => {
//     const { Payload, forReferesh } = arg;
//     const response = await apiRequest("POST", "v1/appSetting/deleteAppSetting", Payload);
//     if (response.message) {
//       thunkAPI.dispatch(getAppSettingList(forReferesh));
//     }
//     return response;
//   }
// );



const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    getAllAdminList: [],
    saveAdminData: null,
    updateStatus: null,
    total: null,
    loading: false,
    error: null,
    // deleteAppSetting: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder


      .addCase(adminList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminList.fulfilled, (state, action) => {
        state.loading = false;
        state.getAllAdminList = action?.payload?.data?.list;
      })
      .addCase(adminList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(saveAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.saveAdminData = action?.payload;
      })
      .addCase(saveAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


      .addCase(adminStatusUpdate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminStatusUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.updateStatus = action?.payload;
      })
      .addCase(adminStatusUpdate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


    // .addCase(updateAppSettingsStatus.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(updateAppSettingsStatus.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.updateStatusAppSetting = action?.payload;
    // })
    // .addCase(updateAppSettingsStatus.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message;
    // })

    // .addCase(deleteAppSetting.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(deleteAppSetting.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.deleteAppSetting = action?.payload;
    // })
    // .addCase(deleteAppSetting.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message;
    // })










  },
});

export default adminSlice.reducer